import type { ConfluenceSubmitPromptOnPageCreateCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';
import { CommandHandler, type PassThroughCommandProps } from '@atlassian/editor-rovo-bridge';

import { fg } from '@confluence/feature-gating';

import { log } from '../utils/aifc-logging';
import type { ExtraCommandProps } from '../RovoBridgeCommandListener';

export class SubmitPromptCommandHandler extends CommandHandler<
	ConfluenceSubmitPromptOnPageCreateCommandProperties,
	void
> {
	constructor(
		props: PassThroughCommandProps,
		private extraProps: Pick<ExtraCommandProps, 'generateAIHeaderImage'>,
	) {
		super(props);
	}

	execute(payload: ConfluenceSubmitPromptOnPageCreateCommandProperties): Promise<void> {
		log('handle confluence-prompt-submit-on-page-create-command');
		if (this.extraProps.generateAIHeaderImage && fg('aifc_header_image_pseudo_title_enabled')) {
			return this.extraProps.generateAIHeaderImage({ adfContent: payload.userPrompt });
		}

		return Promise.resolve();
	}
}
